<template>
</template>

<script>
export default {
  name: 'page-diet-colaboration',
  data() {
    return {
    };
  },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/diets/details/colaboration/page-diet-colaboration.vue